import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const contentWrap = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--space-150);
  margin: var(--space-250) 0 var(--space-100) 0;
`;

export const ulStyle = css`
  display: grid;
  gap: var(--space-175);
  padding: 0;
  margin: 0;
`;

export const liStyle = css`
  display: flex;
  flex-direction: row;
  height: 32px;

  ${breakpoints.only.smMobile} {
    height: 24px;
  }
`;

export const modalContentElementTextStyle = css`
  width: 100%;
  padding: var(--space-60) 0 var(--space-60) var(--space-150);

  ${breakpoints.only.smMobile} {
    padding: 0 0 var(--space-25) var(--space-100);
  }
`;

export const imgStyle = css`
  width: 32px;
  height: 32px;

  ${breakpoints.only.smMobile} {
    width: 24px;
    height: 24px;
  }
`;
